(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  //Configurator Menu Slider
  // $('.pl-selectionMenu.is-mobile').slick({
  //   centerMode: true,
  //   centerPadding: '60px',
  //   slidesToShow: 3,
  //   infinite: false,
  //   touchThreshold: 90,
  //   variableWidth: true
  // });

  var sessionData = JSON.parse(localStorage.getItem("configData"));

  var seenResumeBtn = sessionStorage.getItem('seen_resume_btn');

  if (sessionData != undefined || sessionData != null) {
    var queryString = buildURLParams();
    var configStep = sessionData.configStep;
    var configType = sessionData.configType;
    var thePage = '/configurator/' + configType;
    var configImg = sessionData.productImage;

    if (configStep != undefined && configStep.length > 0) {
      thePage += '/' + configStep + '/';
    }
    $('.resumeBuild').find('.resumeModelImage').find('img').attr('src', configImg);
    $('#resumeBuildLink').attr('href', 'https://' + window.location.hostname + thePage + queryString);
    if (!window.location.href.includes('configurator')) {
      $('.resumeBuild').show();
      if (!seenResumeBtn) {
        $('.resumeBuild').toggleClass('active-open');
        $('.resumeBuild').toggleClass('show');
        sessionStorage.setItem('seen_resume_btn', true);

        var timer = setTimeout(function () {
          $('.resumeBuild').toggleClass('show');
          $('.resumeBuild').toggleClass('active-open');
        }, 5000);
      }
    }
  }

  $(".verticalTab").click(function () {
    $(".resumeBuild").toggleClass("show");
    if (timer) {
      clearTimeout(timer);
    }
  });

  // $('.pl-swatch-modal .pl-modal-content').each(function(index){
  //   $(this).children('.pl-modal-slider').slick({
  //     infinite:false,
  //     touchThreshold: 70
  //   });
  // });
  //end mobile menu setup

  //Configurator Checkbox ~ Radio Behavior
  $(".pl-check").change(function () {
    $(".pl-check").prop('checked', false);
    $(this).prop('checked', true);
  });

  //Zoom Modal
  $(".pl-zoom-modal-trigger").click(function (e) {
    e.stopPropagation();
    $(".pl-zoom-modal").fadeIn();
    $('html').css('overflow-y', 'hidden');
  });
  $(".pl-zoom-modal .pl-modal-close").click(function () {
    $(".pl-zoom-modal").fadeOut();
    $('html').css('overflow-y', 'scroll');
  });

  $(".pl-explore-modal .pl-modal-close").click(function () {
    $(".pl-explore-modal").fadeOut();
    $('html').css('overflow-y', 'scroll');
    $('.pl-modal-content .bg-night.button-reset').click();
    $('.pl-modal-content .nav-item .swap-interior').click();
    $('.m-hotspot-carousel-slide').hide();
  });

  $('.pl-modal').on('click', function (e) {
    if ($(e.target).hasClass('pl-modal-flex') || $(e.target).hasClass('pl-modal-inner')) {
      $('html').css('overflow-y', 'scroll');
      if ($(this).hasClass("pl-explore-modal")) {
        $('.pl-modal-content .bg-night.button-reset').click();
        //$('.pl-modal-content .nav-item .swap-interior').click();
        $('.m-hotspot-carousel-slide').hide();
        $(this).fadeOut();
      } else if ($(this).hasClass('pl-swatch-modal') && !$(this).hasClass('pl-option-modal')) {
        $(".pl-swatch-modal").removeClass("activate");
        $('.pl-swatch-modal .slick-initialized').each(function (index) {
          $(this).slick('unslick');
        });
        $('.pl-swatch-modal .pl-modal-content').hide();
      } else if ($(this).hasClass('pl-swatch-modal') && $(this).hasClass('pl-option-modal')) {
        $(".pl-swatch-modal").removeClass("activate");
        $('.pl-modal-slider').slick('unslick');
        $('.option-gallery-slider').slick('unslick');
        $('html').css('overflow-y', 'scroll');
      }if ($(this).hasClass('contact-modal')) {
        //intentionally do nothing
      } else {
        $(this).fadeOut();
      }
    }
  });

  //Modal Gallery Expand Button
  $(".pl-gallery-expand").click(function () {
    $(this).toggleClass("is-active");
    $(".pl-grid-item-wrapper").toggleClass("show");
  });

  //Summary Accordions
  $(".pl-accordion-label").click(function () {
    $(this).parent(".pl-accordion").children(".pl-accordion-drop").stop().slideToggle("slow", function () {});
    $(this).toggleClass('open');
  });

  //Anchor Scroll - Hide Menu
  $(".pl-anchor").click(function () {
    $(".pl-subnav-wrapper .m-subnav-toggle").toggleClass("is-active");
    $(".pl-subnav-wrapper .m-subnav-nav").css('display', 'none');
  });

  //Anchor SmoothScroll
  $(function () {
    $('a[href*="#"]:not([href="#"])').click(function () {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        $('.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          console.log('we smoothscrollin');
          $('html, body').animate({
            scrollTop: target.offset().top - 110
          }, 1000);
          return false;
        }
      }
    });
  });
});

function buildURLParams() {
  var includeZip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var configData = JSON.parse(localStorage.getItem('configData'));
  var queryString = '?';

  for (var keys = Object.keys(configData), x = 0, stop = keys.length; x < stop; x++) {
    var key = keys[x],
        val = configData[key],
        badKeys = ['quoteData', 'userData', 'modelName', 'productImage', 'configType', 'firstName', 'lastName', 'configStep', 'email'];

    if (!includeZip) {
      badKeys.push('zip');
    }

    if (!badKeys.includes(key)) {
      if (x == keys.length - 1) {
        queryString += key + '=' + configData[key];
      } else {
        queryString += key + '=' + configData[key] + '&';
      }
    }
  }

  return queryString;
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$.sanitize = function (input) {
  return input.replace(/<(|\/|[^>\/bi]|\/[^>bi]|[^\/>][^>]+|\/[^>][^>]+)>/g, '');
};

var dealerData, stateData, countryData;

function doDealerSearch(zip) {
  var accessToken = 'pk.eyJ1IjoiYmFydGhvbG9tZXdmaXNoMjk4MyIsImEiOiJjaW84ampjZ2EwMnRhdnpsejdpNXU0NG1wIn0.8U2l4oNvAzzPMN_yavGRKw';

  mapboxgl.accessToken = accessToken;
  L.mapbox.accessToken = accessToken;
  var geoCoder = L.mapbox.geocoder('mapbox.places');

  $.get('/wp-content/themes/airstream-2018-theme/templates/tool-locate/stateData.json', function (data) {
    stateData = data;
    $.get('/wp-content/themes/airstream-2018-theme/templates/tool-locate/countryData.json', function (data) {
      countryData = data;
      $.get('https://airhub.airstream.com/dealer', function (data) {
        dealerData = data;
        geoCoder.query(zip, processResults);
      });
    });
  });
}

function processResults(err, data) {
  var result = data.results.features[0],
      dealer;

  if (result.place_type.includes('region')) {
    dealer = locateDealer(stateData, result, dealerData);
    updateDealerData(dealer);
  } else {
    dealer = locateDealer(countryData, result, dealerData);
    updateDealerData(dealer);
  }
}

function updateDealerData(dealer) {
  var dealerAddress = '<span>' + dealer.address1 + '</span><span>' + dealer.city + ', ' + dealer.state + ' ' + dealer.zip + '</span><span>' + dealer.phone + '</span>';

  $('#dealerId').val(dealer.id);
  $('#dealerAirId').val(dealer.airstream_id);

  $('.dealer-detail .pl-dealer-name').text(dealer.name);
  $('.dealer-detail .pl-dealer-address').html(dealerAddress);
  if (dealer.five_star_rivet) {
    $('.dealer-detail .pl-form-rivet-logo').show();
  }

  $('#zipPrompt').hide();
  $('.dealer-detail').show();

  //console.log(dealer);
}

function locateDealer(bounds, currentResult, dealerData) {
  var searchWithin;

  $.each(bounds.features, function (index, feature) {
    //console.log(currentResult.place_name + ' = ' + feature.properties.name);
    if (currentResult.place_name.indexOf(feature.properties.name) !== -1) {
      searchWithin = {
        'type': 'FeatureCollection',
        'features': [feature]
      };
    }
  });

  var point = turf.point(currentResult.geometry.coordinates);
  var dataCopy = $.extend(true, {}, dealerData);
  var fc = turf.featureCollection(dataCopy.features);
  var within = turf.within(fc, searchWithin);
  var results = {
    'type': 'FeatureCollection',
    'features': []
  };
  var options;
  var center;
  var chosenIndex;

  if (!within.features.length) {
    alert('No dealers matched your search.');
    this.reset();
    return;
  }

  resultsLength = 1;
  if (currentResult.place_type.includes('region')) {
    resultsLength = within.features.length;
  }

  // get 3 closest dealers if city or zip
  // if state, get all dealers in state
  for (var i = 0; i < resultsLength; i++) {
    var nearest = turf.nearest(point, within);
    results.features.push(nearest);
    $.each(within.features, function (index, feature) {
      if (nearest.geometry.coordinates !== feature.geometry.coordinates) return true;
      chosenIndex = index;
      return false;
    });
    within.features.splice(chosenIndex, 1);
  }

  center = turf.center(results);

  return results.features[0].properties;
}

},{}]},{},[1]);
